// extracted by mini-css-extract-plugin
export default {"cheatSheetModal":"ShortcutsCheatSheetModal_cheatSheetModal__Mbc6U","content":"ShortcutsCheatSheetModal_content__PO1D5"};